<template>
    <div class="schema-selector-wrapper">
        <h3 class="pt-2">Product Types</h3>
        <div class="row">
            <div v-if="enabledSchemas.length == 0" class="col-md-12 empty-list">
                No product types have been added to this channel yet.
            </div>
            <div v-else class="col-md-12">
                <div class="product-type d-flex align-items-center" v-for="item in enabledSchemas" :key="item.id">{{item.name}} ({{item.status}})</div>
            </div>

        </div>
        <div class="row">
            <div class="col-md-6">
                <select2 ref="selector" :disabled="false" v-model="selectedSchemaId" :multiple="false" class="attribute_select" :config="{placeholder: '', width: '100%'}">
                    <option value="">Add New Product Types...</option>
                    <option v-for="option in disabledSchemas" :value="option.id" :key="option.id">{{option.name}}</option>
                </select2>
            </div>
            <div class="col-md-6">
                <button :disabled="selectedSchemaId == ''" v-on:click="handleAddSchemaButtonClick()" type="button" class="btn btn-header">Request Product Type Setup</button>
            </div>
        </div>

    </div>
</template>

<script>

import select2 from 'select2';
import axios from 'axios';

export default {
    name: 'schema-selector',
    components: {},
    props: {
        channelId: Number,
    },
    data() {
        return {
            showSideModal: false,
            allSchemas: [],
            selectedSchemaId: '',
        };
    },
    computed: {
        enabledSchemas() {
            return this.allSchemas.filter(el => {
                return el.available == 1;
            });
        },
        disabledSchemas() {
            return this.allSchemas.filter(el => {
                return el.available == 0;
            });
        }
    },
    created() {
        axios.get(`/channels/${this.channelId}/disabledschemas`)
        .then((results) => {
            //add returned schemas to watched data
            results.data.forEach((element, index) => {
                this.$set(this.allSchemas, index, element);
            });
        });
    },
    methods: {
        handleAddSchemaButtonClick() {

            axios.post(`/channels/${this.channelId}/enableschema/${this.selectedSchemaId}`)
            .then((results) => {
                console.log(results);
            });

            this.allSchemas.forEach(ele => {
                if (ele.id == this.selectedSchemaId) {
                    ele.enabled = 1;
                }
            });
            this.selectedSchemaId = '';

        },
    }
};
</script>

<style lang="scss">

    .schema-selector-wrapper {
        position: relative;
    }
    .btn-header {
        background-color: #25628F;
        border-color: #25628F;
        color: white;
    }
    .empty-list {
        color: #AB5755;
    }
    .product-type {
        height: 50px;
        width: 100%;
        border: 1px solid #D7DCEB;
        border-radius: 5px;
        margin-top: 2px;
        margin-bottom: 2px;
        padding-left: 15px;
    }

    .product-title {
        padding-left: 15px;
    }

    .row {
        padding-bottom: 30px;
    }

</style>
